// Localised display helpers for values stored in French in the DB / backend config.
// Each helper takes the `t` function from useContent() and maps a stable value to a CMS key.

export const speedLabel = (t, v) => {
  if (v === "Instantané") return t("badge.speed.instant", "Instantané");
  if (v === "Rapide") return t("badge.speed.fast", "Rapide");
  return v || "";
};

const DROP_KEYS = {
  "Faible": ["badge.drop.low", "Faible"],
  "Moyen": ["badge.drop.medium", "Moyen"],
  "Très faible": ["badge.drop.very_low", "Très faible"],
};
export const dropLabel = (t, v) => (DROP_KEYS[v] ? t(DROP_KEYS[v][0], DROP_KEYS[v][1]) : v || "");

export const refillWord = (t) => t("services.card.refill", "Recharge");
export const noRefillWord = (t) => t("services.card.no_refill", "Sans recharge");

const COUNTRY_KEYS = {
  COD: ["country.COD", "RD Congo"],
  CIV: ["country.CIV", "Côte d'Ivoire"],
  SEN: ["country.SEN", "Sénégal"],
  CMR: ["country.CMR", "Cameroun"],
  KEN: ["country.KEN", "Kenya"],
  GHA: ["country.GHA", "Ghana"],
  NGA: ["country.NGA", "Nigeria"],
  UGA: ["country.UGA", "Ouganda"],
  TZA: ["country.TZA", "Tanzanie"],
  ZMB: ["country.ZMB", "Zambie"],
  RWA: ["country.RWA", "Rwanda"],
};
export const countryLabel = (t, code, fallback) =>
  COUNTRY_KEYS[code] ? t(COUNTRY_KEYS[code][0], COUNTRY_KEYS[code][1]) : fallback || code;

const TIMELINE_KEYS = {
  created: ["order.timeline.created", "Commande créée"],
  payment: ["order.timeline.payment", "Paiement confirmé depuis le portefeuille"],
  delivery_started: ["order.timeline.delivery_started", "Début de livraison"],
  in_progress: ["order.timeline.in_progress", "Livraison en cours"],
  partial: ["order.timeline.partial", "Livraison partielle"],
  completed: ["order.timeline.completed", "Livraison terminée"],
  refunded: ["order.timeline.refunded", "Commande remboursée"],
  cancelled: ["order.timeline.cancelled", "Livraison annulée"],
  failed: ["order.timeline.failed", "Livraison interrompue"],
};
export const timelineLabel = (t, key, fallback) =>
  TIMELINE_KEYS[key] ? t(TIMELINE_KEYS[key][0], TIMELINE_KEYS[key][1]) : fallback || "";

const STATUS_KEYS = {
  "En attente": ["order.status.pending", "En attente"],
  "En cours": ["order.status.in_progress", "En cours"],
  "Remboursée": ["order.status.refunded", "Remboursée"],
  "Annulée": ["order.status.cancelled", "Annulée"],
  "Échouée": ["order.status.failed", "Échouée"],
  "Livraison partielle": ["order.status.partial", "Livraison partielle"],
  "Terminé avec succès": ["order.status.completed", "Terminé avec succès"],
};
export const statusLabel = (t, v) => (STATUS_KEYS[v] ? t(STATUS_KEYS[v][0], STATUS_KEYS[v][1]) : v || "");
